/**
 * In-app notifications (docs/15-notifications.md). Most are about an activity the recipient
 * is tagged in (the author of the activity is the actor); the rest carry an announcement
 * (docs/17-announcements.md), whose author is the actor.
 */
export const NotificationType = {
    /** You were tagged in a published activity (or a draft you were tagged in was published). */
    ACTIVITY_TAGGED: 'ACTIVITY_TAGGED',
    /** The date, time or place of an activity you are tagged in changed. */
    ACTIVITY_CHANGED: 'ACTIVITY_CHANGED',
    /** An activity you are tagged in was cancelled. */
    ACTIVITY_CANCELLED: 'ACTIVITY_CANCELLED',
    /** Your activity has ended: fill in its report (participation, results, materials). */
    ACTIVITY_REPORT_DUE: 'ACTIVITY_REPORT_DUE',
    /** Leadership or the administrator sent an announcement to you. */
    ANNOUNCEMENT: 'ANNOUNCEMENT',
};
//# sourceMappingURL=notification.js.map